import { BehaviorSubject, Subject } from 'rxjs';

export class SharedNotificationService {
  constructor() {
    if (typeof SharedNotificationService.instance === 'object') {
      return SharedNotificationService.instance;
    }

    this.destroy$ = new Subject(false);
    this.userSubscriber$ = new BehaviorSubject([]);
    this.lastLoadedRequestId = null;

    SharedNotificationService.instance = this;
    return this;
  }

  get subscriberAsObservable() {
    return this.userSubscriber$.asObservable();
  }

  set storeSubscriberValue(users) {
    this.userSubscriber$.next(users);
  }

  set unsubscribeDestroySubject(booleanValue) {
    this.destroy$.next(booleanValue);
    this.destroy$.complete();
  }
}
